import React, { useEffect, useState, useCallback } from "react";
import Style from "../style/blog.module.scss";
import { useAppDispatch } from "../redux/hooks";
import { fetchBlogs } from "../redux/Slice";
import { useParams } from "react-router-dom";
import Loader from "../Loader/Loader";

const Blog = () => {
  const { category } = useParams();
  const dispatch = useAppDispatch();
  const [blogs, setBlogs] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loadingMore, setLoadingMore] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [initialLoading, setInitialLoading] = useState(true);
  const itemsPerPage = 6;
  const baseUrl = "https://backend.onedialusa.com/assets/img/blogs/";

  const fetchBlogsBatch = useCallback(
    async (page: number) => {
      setLoadingMore(true);

      try {
        const response = await dispatch(
          fetchBlogs({ page, limit: itemsPerPage })
        ).unwrap();
        const newBlogs =
          response?.blogs?.blogs?.data || response?.blogs?.data || [];

        console.log("Full response:", response);

        console.log("Fetched new blogs:", newBlogs);

        if (newBlogs.length > 0) {
          setBlogs((prev) => {
            const updatedBlogs = [...prev, ...newBlogs];
            console.log("Updated blogs state:", updatedBlogs);
            return updatedBlogs;
          });
        }

        if (newBlogs.length < itemsPerPage) {
          setHasMore(false);
        }
      } catch (error) {
        console.error("Failed to fetch blogs:", error);
      }

      setLoadingMore(false);
      setInitialLoading(false);
    },
    [dispatch]
  );

  useEffect(() => {
    fetchBlogsBatch(1);
  }, [fetchBlogsBatch]);

  const extractPTags = (html: any) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    const pTags = tempDiv.querySelectorAll("p");
    return Array.from(pTags)
      .map((p) => p.outerHTML)
      .join("");
  };

  const filteredBlogs = category
    ? blogs.filter(
        (item) =>
          item.categoryName?.toLowerCase().replaceAll(" ", "-") === category
      )
    : blogs;

  const paginatedBlogs = filteredBlogs.slice(0, currentPage * itemsPerPage);

  const loadMoreBlogs = () => {
    const nextPage = currentPage + 1;
    setCurrentPage(nextPage);
    fetchBlogsBatch(nextPage);
  };

  return (
    <div className={Style.container}>
      <div className={Style.wrapper}>
        <div className={Style.title}>
          <h2>{category ? `${category.toUpperCase()}` : "All Blogs"}</h2>
        </div>

        <div className={Style.Article}>
          {initialLoading ? (
            <Loader />
          ) : paginatedBlogs.length > 0 ? (
            paginatedBlogs.map((item) => (
              <a
                href={`/blog/${item.title.toLowerCase().replaceAll(" ", "-")}/${
                  item.id
                }`}
                key={item.id}
              >
                <div className={Style.ArticleData}>
                  <img
                    src={
                      item.image
                        ? `${baseUrl}${item.image}`
                        : "https://images.unsplash.com/photo-1499750310107-5fef28a66643?fm=jpg&q=60&w=3000"
                    }
                    onError={(e: any) => {
                      e.target.src =
                        "https://images.unsplash.com/photo-1499750310107-5fef28a66643?fm=jpg&q=60&w=3000";
                    }}
                    alt={item.title}
                    loading="lazy"
                    width="100%"
                    height="auto"
                    style={{ objectFit: "cover" }}
                  />
                  <div className={Style.ArticleText}>
                    <h2>{item.title}</h2>
                    <div
                      className={Style.text}
                      dangerouslySetInnerHTML={{
                        __html: extractPTags(item.content),
                      }}
                    />
                    <span>Read More</span>
                  </div>
                </div>
              </a>
            ))
          ) : (
            <p>No blogs available.</p>
          )}
        </div>
        {hasMore && !initialLoading && (
          <div className={Style.pagination}>
            <button onClick={loadMoreBlogs} disabled={loadingMore}>
              {loadingMore ? "Loading..." : "Load More"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Blog;
